<template>
  <FormulateForm
      v-model="formValues"
      @submit="onSubmit"
      :form-errors="formErrors"
      novalidate
  >
    <FormulateErrors />

    <FormulateInput
        label="E-mail"
        type="email"
        name="email"
        validation="^required|email"
        :validation-messages="{
        required: 'Zadejte prosím email',
        email: 'Vámi zadaný e-mail nemá správný formát',
      }"
        error-behavior="submit"
    />

    <FormulateInput
        label="Heslo"
        :type="isPassword ? 'password' : 'text'"
        name="password"
        validation="^required|min:8"
        :validation-messages="{
        required: 'Zadejte prosím heslo',
        min: 'Heslo musí obsahovat minimálně 8 znaků',
      }"
        error-behavior="submit"
    >
      <template #label="{ label, id }">
        <label :for="id">
          {{ label }}
          <span
              :class="['password-icon', { isvisible: !isPassword }]"
              @click="isPassword = !isPassword"
          />
        </label>
      </template>
    </FormulateInput>

    <div class="page-form__conditions">
      <FormulateInput
          name="approvalTerms"
          type="checkbox"
          validation="accepted"
          :validation-messages="{
          accepted: 'Potvrzení souhlasu s podmínkami je povinné',
        }"
          error-behavior="submit"
      >
        <template #label="{ id }">
          <label :for="id">
            <span class="required">*</span>
            Souhlasím s
            <a href="https://www.cncenter.cz/podminky-uzivani" target="_blank">
              Podmínkami pro užívání služby informační společnosti
            </a>
            a seznámil/a jsem se
            <a href="https://www.cncenter.cz/informace-o-zpracovani-obecna" target="_blank">
              Informací o zpracování osobních údajů
            </a>
          </label>
        </template>
      </FormulateInput>

      <FormulateInput
          name="approvalNews"
          type="checkbox"
          error-behavior="submit"
      >
        <template #label="{ id }">
          <label :for="id">
            Chci dostávat novinky o speciálních akcích, soutěžích a dalších
            zajímavostech ze světa vydavatele.
          </label>
        </template>
      </FormulateInput>

      <FormulateInput
          name="approvalPartners"
          type="checkbox"
          error-behavior="submit"
      >
        <template #label="{ id }">
          <label :for="id">
            Chci dostávat zajímavé nabídky od partnerů vydavatele nebo tipy na
            další služby vydavatele, které se povahou liší od aktuálně zvolené
            služby.
            <br />
            <a
                href="https://www.cncenter.cz/souhlas-se-zasilanim-obchodnich-sdeleni"
                target="_blank"
            >
              Podrobnosti k souhlasu se zasíláním obchodních sdělení
            </a>
          </label>
        </template>
      </FormulateInput>
    </div>

    <FormulateInput type="submit" label="Registrovat se" :disabled="isSubmiting">
      <Spinner v-if="isSubmiting" :size="24" color="#ffffff" />
    </FormulateInput>
  </FormulateForm>
</template>

<script>
import BaseFormMixin from '@/mixins/BaseFormMixin';
import { AUTH_REGISTER_REQUEST } from '@/store/actions/auth';
import Spinner from '@/components/ui/Spinner';

export default {
  name: 'RegistrationForm',
  mixins: [BaseFormMixin],
  components: { Spinner },

  data() {
    return {
      formValues: {
        approvalTerms: false,
        approvalNews: true,
        approvalPartners: false,
      },
    };
  },

  methods: {
    onSubmit(data) {
      const {
        email,
        password,
        approvalTerms,
        approvalNews,
        approvalPartners,
      } = data;

      const smartEmailingListIds = [];
      if (approvalNews) smartEmailingListIds.push(613);
      if (approvalPartners) smartEmailingListIds.push(956);

      this.handleSubmit(AUTH_REGISTER_REQUEST, {
        email,
        password,
        termsConfirmed: !!approvalTerms,
        termsNewsConfirmed: !!approvalNews,
        termsPartnersConfirmed: !!approvalPartners,
        smartEmailingListIds,
        serviceId: this.serviceId,
        redirectUrl: this.redirectUrl,
      });
    },
  },
};
</script>
